/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useInventarioMovimiento } from "../../../../contexto/provider/InventarioMovimientoContext.js";
import { useProductos } from "../../../../contexto/provider/ProductosContext.js";
import { usePeriodoInventario } from "../../../../contexto/provider/InventarioPeriodosContext.js";

import SelectGenerico from "../../../../componentsUI/formularios/selector/selectorGenerico.js";

import "./formajustes.css";

export default function CrearAjusteInventarioForm() {
  // Context- hook
  const { registrarMovimiento } = useInventarioMovimiento();
  const { productos, cargarProductosInsumos, cargarProductos } = useProductos();
  const { periodos } = usePeriodoInventario();

  const [periodoId, setPeriodoId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [codigoCreado, setCodigoCreado] = useState(null);

  const [form, setForm] = useState({
    idProducto: "",
    cantidad: 1,
    origen: "ajuste", // valor por defecto
    tipoMovimiento: "entrada",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const payload = { ...form, periodoId };
      console.log("payload", payload);
      const resultado = await registrarMovimiento(payload);

      setCodigoCreado(resultado.id_movimiento);
      setSuccess(true);

      setForm({
        idProducto: "",
        cantidad: 1,
        origen: "ajuste",
        tipoMovimiento: "entrada",
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  // CARGAR PRODUCTOS
  useEffect(() => {
    const cargarTodos = async () => {
      await Promise.all([cargarProductos(), cargarProductosInsumos()]);
    };

    cargarTodos();
  }, [cargarProductos, cargarProductosInsumos]);

  console.log("seleccion", periodoId);

  return (
    <div className="form-container">
      <form className="form-card" onSubmit={handleSubmit}>
        <h2 className="form-title">Crear Ajuste de Inventario</h2>
        <div className="form-group">
          <SelectGenerico
            id="select-periodo"
            label="Seleccionar periodo"
            value={periodoId}
            onChange={(valor) => {
              if (!valor) return setPeriodoId(null);
              // Si viene objeto, toma id; si viene número, usa directamente
              setPeriodoId(typeof valor === "object" ? valor.id : valor);
            }}
            options={periodos}
            getOptionValue={(p) => p.id}
            getOptionLabel={(p) => `${p.anio}-${p.mes}`}
          />
        </div>
        <div className="form-group">
          <SelectGenerico
            id="select-producto"
            label="Seleccionar producto"
            value={form.idProducto}
            onChange={(valor) => {
              setForm((prev) => ({
                ...prev,
                idProducto: valor,
              }));
            }}
            options={productos}
            getOptionValue={(p) => p.Codigo}
            getOptionLabel={(p) => `${p.Codigo} - ${p.nombre}`}
          />
        </div>
        {/* Fila 1: Producto y Cantidad */}
        <div className="form-group-row">
          {/* Producto */}

          {/* Cantidad */}
          <div className="form-group">
            <label htmlFor="cantidad" className="form-label">
              Cantidad
            </label>
            <input
              id="cantidad"
              name="cantidad"
              type="number"
              value={form.cantidad}
              min={1}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>
        </div>

        {/* Origen */}
        <div className="form-group">
          <label htmlFor="origen" className="form-label">
            Origen del Ajuste
          </label>
          <select
            id="origen"
            name="origen"
            value={form.origen}
            onChange={handleChange}
            className="form-input"
            required
          >
            <option value="correccion">Corrección</option>
            <option value="ajuste">Ajuste</option>
            <option value="provision">Provisión</option>
          </select>
        </div>

        {/* Botón de submit */}
        <button type="submit" className="btn-android w-100" disabled={loading}>
          {loading ? "Creando..." : "Registrar Ajuste"}
        </button>

        {/* Mensajes */}
        {error && <p className="form-msg error">{error}</p>}
        {success && (
          <p className="form-msg success">
            Movimiento creado correctamente. ID: {codigoCreado}
          </p>
        )}
      </form>
    </div>
  );
}
